import {
  Component,
  Inject,
  OnInit,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiEndpointsService } from 'src/app/core/services/api-endpoints.service';
import { DataService } from 'src/app/core/services/data.service';
import { IHttpService } from 'src/app/core/services/ihttp.service';
import { PosWarningService } from 'src/app/core/services/posWarning.services';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'src/app/directives/sortable/sortable.directive';
import { Observable } from 'rxjs';
import { PosWarning } from 'src/app/core/classes/posWarning';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'dq-pos-warnings',
  templateUrl: './pos-warnings.component.html',
  styleUrls: ['./pos-warnings.component.scss'],
})
export class PosWarningsComponent implements OnInit {
  warnings: any[] = [];

  posWarnings$!: Observable<PosWarning[]>;
  posWarnings: PosWarning[] = [];
  posWarningsPaginated: PosWarning[] = [];

  total: number = 0;
  page = 1;
  pageSize = 10;
  public isCollapsed = false;

  @ViewChildren(NgbdSortableHeader) modalHeaders!:
    | QueryList<NgbdSortableHeader>
    | undefined;

  constructor(
    private apiEndpointsService: ApiEndpointsService,
    private dataService: DataService,
    @Inject('HttpService') private httpService: IHttpService,
    translate: TranslateService,
    private posWarningService: PosWarningService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.posWarningService.iniPosWarnings();
    this.posWarnings$ = this.posWarningService.posWarningFiltered$;
    this.posWarnings$.subscribe((posWarnings: PosWarning[]) => {
      this.posWarningsPaginated = posWarnings.slice(
        (this.page - 1) * this.pageSize,
        (this.page - 1) * this.pageSize + this.pageSize
      );
      this.posWarnings = posWarnings;
      this.total = posWarnings.length;
    });
  }

  onSort({ column, direction }: SortEvent) {
    if (this.modalHeaders) {
      this.modalHeaders.forEach((header) => {
        if (header.sortable !== column) {
          header.direction = '';
        }
      });

      this.posWarningService.sortColumn = column;
      this.posWarningService.sortDirection = direction;
    }
  }

  applyFilterPosWarnings($event: any) {
    this.posWarningService.filterPosWarnings(
      ($event.target as HTMLInputElement).value
    );
  }

  refreshPosWarnings() {
    this.posWarningsPaginated = this.posWarnings.slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize
    );
  }
  viewDetail(posId: any) {
    this.router.navigate(['/detail', posId]);
    this.activeModal.close();
  }
  close() {
    this.activeModal.close();
  }
}
